var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.363,
    height: 13.363,
    viewBox: "0 0 13.363 13.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9c9fa3",
    d: "M12.7,2.673H11.359V8.686H2.673v1.336a.631.631,0,0,0,.668.668h7.35l2.673,2.673V3.341A.631.631,0,0,0,12.7,2.673ZM10.023,6.682V.668A.631.631,0,0,0,9.354,0H.668A.631.631,0,0,0,0,.668v9.354L2.673,7.35H9.354A.631.631,0,0,0,10.023,6.682Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMessage);
export default __webpack_public_path__ + "static/media/totalMessage.f48c7997.svg";
export { ForwardRef as ReactComponent };